import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import localePtBr from '@angular/common/locales/pt';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsPe from '@angular/common/locales/es-PE';
import { NgModule } from '@angular/core';
import { HttpInterceptorService } from '@core/services/core/http-interceptor.service';
registerLocaleData(localeEs);
registerLocaleData(localePtBr);
registerLocaleData(localeEsMx);
registerLocaleData(localeEsPe);

@NgModule({
  declarations: [],
  imports: [CommonModule, OverlayModule],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }]
})
export class CoreModule {}
